import { Dispatch } from '@reduxjs/toolkit'
import { CreateFilter } from 'api/Identity/Types/CreateFilter'
import { SimpleUserResponse } from 'api/Identity/Types/UserResponse'
import { TokenStorage } from 'api/tokenStorage'
import { persistor } from 'store/store'
import { getIdFromLocationHeader } from 'utils/api'
import { IdentityApiClient } from 'utils/api/identityApi'

import { identitySlice } from './identity.slice'

export const fetchRegionsAction = (identityApiClient: IdentityApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await identityApiClient.fetchRegions()
      dispatch(identitySlice.actions.fetchRegions(response))
    } catch (e) {
      console.error('Cannot get regions', e)
    }
  }
}

export const fetchDateFormatAction = (identityApiClient: IdentityApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await identityApiClient.fetchDateFormat()
      dispatch(identitySlice.actions.fetchDateFormat(response))
    } catch (e) {
      console.error('Cannot during get format dates.', e)
    }
  }
}

export const fetchCountriesAction = (identityApiClient: IdentityApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await identityApiClient.fetchCountries()
      dispatch(identitySlice.actions.fetchCountries(response))
    } catch (e) {
      console.error('Cannot get countries', e)
    }
  }
}

export const fetchDepartmentsAction = (identityApiClient: IdentityApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await identityApiClient.fetchDepartments()
      dispatch(identitySlice.actions.fetchDepartments(response))
    } catch (e) {
      console.error('Cannot get countries', e)
    }
  }
}

export const fetchUserStatuses = (identityApiClient: IdentityApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await identityApiClient.fetchUserStatuses()
      dispatch(identitySlice.actions.fetchUserStatuses(response))
    } catch (error) {
      console.error('Cannot get user statuses', error)
    }
  }
}

export const fetchUserKinds = (identityApiClient: IdentityApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await identityApiClient.fetchUserKinds()
      dispatch(identitySlice.actions.fetchUserKinds(response))
    } catch (error) {
      console.error('Cannot get user kinds', error)
    }
  }
}

export const fetchTickmillCompaniesAction = (identityApiClient: IdentityApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await identityApiClient.getTickmillCompanies()
      dispatch(identitySlice.actions.fetchTickmillCompanies(response))
    } catch (e) {
      console.error('Cannot get tickmill companies', e)
    }
  }
}

export const fetchMyTickmillCompaniesAction = (identityApiClient: IdentityApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await identityApiClient.getMyTickmillCompanies()
      dispatch(identitySlice.actions.fetchMyTickmillCompanies(response))
    } catch (e) {
      console.error('Cannot get my tickmill companies', e)
    }
  }
}

export const fetchFilterTypesAction =
  (identityApiClient: IdentityApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await identityApiClient.fetchFilterType()
      dispatch(identitySlice.actions.fetchFilterTypes(response))
    } catch (e) {
      console.error('Cannot get filter types.', e)
    }
  }

export const fetchFilterAction =
  (identityApiClient: IdentityApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const resp = await identityApiClient.fetchFilters()
      dispatch(identitySlice.actions.fetchFilters(resp))
    } catch (e) {
      console.error('Cannot get filters.', e)
    }
  }

export const saveFilterAction =
  (data: CreateFilter, identityApiClient: IdentityApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const result = await identityApiClient.saveFilter(data)
      const filterId = getIdFromLocationHeader(result.headers.location)
      if (!filterId) {
        return console.error('Error during get id of created filter.')
      }
      const response = await identityApiClient.fetchFilterById(filterId)
      dispatch(identitySlice.actions.fetchFilter(response))
    } catch (e) {
      console.error('Cannot get filters.', e)
    }
  }

export const updateFilterAction =
  (id: string, data: CreateFilter, identityApiClient: IdentityApiClient) =>
  async (): Promise<void> => {
    try {
      await identityApiClient.updateFilterById(id, data)
    } catch (e) {
      console.error('Cannot get filters.', e)
    }
  }

export const removeFilterAction =
  (id: string, identityApiClient: IdentityApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      await identityApiClient.removeFilter(id)
      dispatch(identitySlice.actions.deleteFilter(id))
    } catch (e) {
      console.error('Cannot delete filter, error:.', e)
    }
  }

// TEAMS
export const fetchTeamsAction =
  (identityApiClient: IdentityApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const data = await identityApiClient.fetchTeamsSimpleModel()
      dispatch(identitySlice.actions.fetchTeams(data))
    } catch (e) {
      console.error('Cannot get teams', e)
    }
  }

// ROLES
export const fetchRolesAction =
  (identityApiClient: IdentityApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const roles = await identityApiClient.fetchRoles()
      dispatch(identitySlice.actions.fetchRoles(roles))
    } catch (e) {
      console.error('Cannot get roles', e)
    }
  }

// USERS
export const fetchAdministrationUsersAction = (identityApiClient: IdentityApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const data = await identityApiClient.getUsers()
      dispatch(identitySlice.actions.fetchAdministrationUsers(data))
    } catch (e) {
      console.error(e)
    }
  }
}

export const setAdministrationUsers =
  (users: SimpleUserResponse[]) =>
  (dispatch: Dispatch): void => {
    dispatch(identitySlice.actions.fetchAdministrationUsers(users))
  }

// PERMISSIONS
export const fetchPermissionsAction =
  (identityApiClient: IdentityApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const permissionDTOs = await identityApiClient.fetchPermissions()
      dispatch(identitySlice.actions.fetchPermissions(permissionDTOs))
    } catch (e) {
      console.error('Cannot get permissions', e)
    }
  }

export const logout = () => (): void => {
  persistor.purge()
  TokenStorage.clear()
  localStorage.clear()
}
